export default "__VITE_ASSET__dt9DfJfd__"